import { 
    Support as SupportIcon,
    BrowseGallery as BrowseGalleryIcon
} from "@mui/icons-material";
import { Box, Container, Grid, IconButton, Paper, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const MentorDashboard = () => {
    const navigate = useNavigate();
    const logoutUser = () => {
        localStorage.removeItem('mtoken')
        navigate('/mentor-login');
    };

    return (
        <Container maxWidth="md" sx={{ marginTop: 5 }}>
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                sx={{ mb: 3 }}
            >
                <Typography variant="h4">DASHBOARD</Typography>
                <IconButton color="primary" onClick={logoutUser}><Typography variant="h6">Logout</Typography></IconButton>
            </Box>
            <Grid container spacing={3} >
                <Grid item xs={6} md={4} sx={{ marginTop: 5,cursor:'pointer' }} onClick={() => navigate('/mentor/student/attendance')}>
                    <Paper elevation={3} sx={{
                        p: 3,
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'column',
                        borderRadius: 10,
                        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                        backgroundColor: '#fff',
                        transition: 'background-color 0.3s',
                        '&:hover': {
                        backgroundColor: '#f1f1f1',
                        }
                    }}>
                        <Box display="flex" alignItems="center" justifyContent="center" mb={2}>
                            <BrowseGalleryIcon fontSize="large" color="primary" />
                        </Box>
                        <Typography align="center" variant="subtitle1">
                            STUDENT ATTENDANCE
                        </Typography>
                    </Paper>
                </Grid>
                <Grid item xs={6} md={4} sx={{ marginTop: 5,cursor:'pointer' }} onClick={() => navigate('/mentor/student/tickets')}>
                    <Paper elevation={3} sx={{
                        p: 3,
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'column',
                        borderRadius: 10,
                        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                        backgroundColor: '#fff',
                        transition: 'background-color 0.3s',
                        '&:hover': {
                        backgroundColor: '#f1f1f1',
                        }
                    }}>
                        <Box display="flex" alignItems="center" justifyContent="center" mb={2}>
                            <SupportIcon fontSize="large" color="primary" />
                        </Box>
                        <Typography align="center" variant="subtitle1">Student Tickets</Typography>
                    </Paper>
                </Grid>
            </Grid>
        </Container>
    );
}

export default MentorDashboard;